import React from 'react';
import { useClinic } from '../../context/ClinicContext';

export default function SiteFooter() {
  const { clinic } = useClinic();
  return (
    <footer className="site-footer">
      <span>{`© ${new Date().getFullYear()} ${clinic?.name || ''}`}</span>
      <a href="#privacy">Privacy</a>
      <a href="#terms">Terms</a>
    </footer>
  );
}
